import clsx from 'clsx';

import { type IconDefinition, renderIcon } from '@gitbook/spine-react';

import { useCurrentTheme } from '../theme';
import { BADGE_KIND_STYLES, type BadgeKind } from './common';

/**
 * Rounded badge to wrap an icon. It can be used as an icon.
 */
export function BadgeIcon(props: {
    kind?: BadgeKind;
    icon: IconDefinition;
    size?: number;
    className?: string;
}) {
    const { kind = 'secondary', icon, size = 20, className } = props;
    const [, styles] = useCurrentTheme(BADGE_KIND_STYLES[kind]);

    return (
        <div
            className={clsx('flex items-center justify-center border', className)}
            style={{
                ...styles.wrapper,
                ...styles.text,
                width: size,
                height: size,
                borderRadius: size,
            }}
        >
            {renderIcon(icon, { size: size * 0.5 })}
        </div>
    );
}
